import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { getProjectsConnectionAndOfferIdString } from '@/modules/Chat/helpers/ChatHelper';
import { RouteNames } from '@/enums/routes/RouteNames';
import { ProjectShortInfo } from '@/modules/Chat/interfaces/ProjectShortInfo';
import { ProjectTabValues } from '@/enums/components/Project/ProjectTabValues';
import HelpPage from '@/shared/components/HelpPage.vue';
import router from '@/router';
import store from '@/store';

interface Props {
    projectInfo: ProjectShortInfo | null;
    isInProjectView?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatContentHeader',
  props: {
    projectInfo: null,
    isInProjectView: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { projectInfo: ProjectShortInfo | null, isInProjectView: boolean };



const bottomRowText = computed(() => {
    if (props.projectInfo == null) {
        return '';
    }
    return getProjectsConnectionAndOfferIdString(props.projectInfo.offerId, props.projectInfo.connection);
});

function openProject() {
    if (props.projectInfo == null) {
        return;
    }

    store.commit('tableData/clearProjectNavigationSettings');

    router.push({
        name: RouteNames.project,
        params: {
            id: props.projectInfo.projectId,
        },
        query: {
            initialTab: `${ProjectTabValues.Basic}`,
        },
    });
}

function openChat() {
    if (props.projectInfo == null) {
        return;
    }

    router.push({
        name: RouteNames.chat,
        params: {
            id: props.projectInfo.projectId,
        },
    });
}

return { __sfc: true,props, bottomRowText, openProject, openChat, HelpPage }
}

})